export default __webpack_public_path__ + "static/media/01d.313893ae.jpg";